import { Component } from 'react';
import GroupAvatar from 'assets/images/groupavatar.svg';
import DataTable from 'Container/DataTable/DataTableContainer';
import Pagination from 'Components/Pagination/index';
import formUrlParams from 'Helpers/urlform';
import { CSVLink } from 'react-csv';
import {  formatDateTime } from 'Components/Common/TimeStamp';
import Image from 'Components/Common/Image';
import { getFormattedText } from 'Helpers/index';
import routesPath from 'Constants/routes.constants';
import { ReactComponent as BaclArrow } from 'assets/images/svg/Left Arrow.svg';
import { UsersFields as Fields, UsersSearchParams as SearchParams } from 'models/Users.model';
import { tableConstants } from 'Constants';
import moment from 'moment';

export default class GroupInfo extends Component {
  constructor(props) {
    super(props);
    const model = {
      headers: [
        {
          className:tableConstants.SMALL_GRID_NAME_WIDTH,
          title: 'Name',
          chooseOption: {
            name: SearchParams.nameSearch, /* API param name */
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          accessor: Fields.name /* API response */,
          sortOption: true,
          isDataEncrypted: true,
          tooltip: true,
           cell: ({ content, isAdmin ,index }) => (
             <td key={ index } className="w-30" >
              { content } { isAdmin === 1 && <span style={ { color: 'red' } }>(Admin)</span> }
            </td>
          )
        },
        {
          className:tableConstants.SMALL_GRID_NAME_WIDTH,
          title: 'Email',
          chooseOption: {
            name: SearchParams.emailSearch, /* API param name */
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          accessor: Fields.emailId /* API response */,
          sortOption: true,
          isDataEncrypted: true,
          tooltip: true
        },
        {
          className:tableConstants.SMALL_GRID_NAME_WIDTH,
          title: 'Status',
          accessor: Fields.status,
          sortOption: false,
        },
        {
            title: 'Added On',
            accessor: 'addedAt',
            sortOption: false,
            cell: (rowDetail) => {
              const { content, index } = rowDetail;
              return (
                <td key={ index }>
                  {moment.utc(content).local().format('DD/MM/YYYY hh:mm A')}
                </td>
              );
            },
          },
      ],
      filtered: [],
      responseArray: [],
      pageLimit: 10,
      initialPage: 1,
      activeSort: {},
      groupId: '',
      groupImage: GroupAvatar,
      groupName: '',
      createdDate: '',
      totalMembers: '',
    }
    this.state = model;
  }
  
  componentDidMount() {
    const { match: { params: { id: groupId } } } = this.props;
    this.setState({ groupId: groupId })
    this.props.fetchGroupDetails(groupId)
    this.props.exportGroupInfo(groupId)
  }

  componentDidUpdate(prevProps) {
    const { id, GroupsInfoList  = { }, totalRecords } = this.props; 
    const { totalMembers } = this.state
    const { id: prevId } = prevProps;
    if(prevId !== id) {
      const groupInfo = GroupsInfoList && GroupsInfoList.length > 0 ? GroupsInfoList[ 0 ] : '';
      groupInfo && this.setState({
        groupImage: groupInfo.groupImage ? groupInfo.groupImage : GroupAvatar,
        groupName: groupInfo.groupName,
        ...(!totalMembers && { totalMembers: groupInfo.totalMembers || totalRecords }),
        createdDate: groupInfo.createdAt,
      })
    }
  }

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort, groupId } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
          updatedFilter = [
              ...this.state.filtered,
              activeSort
          ]
      }
      this.props.fetchGroupDetails(groupId, updatedFilter);
      this.props.exportGroupInfo(groupId, updatedFilter)
    });
  }
  
  /**
   * @method sortTable
   * @summary sort for view data
   * @param {name} sortAttribite - Query string name
   * @return { function } formUrlSort
   */
  sortTable = (sortAttribite) => {
    const { activeSort } = this.state
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.setState({
      activeSort: { id: sortAttribite, value: sortType },
    }, () => {
      this.formUrlSort();
    })
  }

  /**
   * @method formUrlSort
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */
  formUrlSort = () => {
    const updatedFilter = [
      ...this.state.filtered,
      this.state.activeSort
    ]
    this.props.fetchGroupDetails(this.state.groupId, updatedFilter);
    this.props.exportGroupInfo(this.state.groupId, updatedFilter)
  }

  handleSearch = (event) => {
    const { name, value } = event.target;
    this.formUrlParams(name, value)
  }

  setPageLimit = (name, value) => {
    this.formUrlParams(name, value, { pageLimit: value })
  }

  handleBack = () => {
    this.props.history.push(routesPath.groups)
  }

  render() {
    const { GroupsInfoList, exportGroupInfoData, totalRecords, currentPage, loading } = this.props
    const { groupImage, groupName, totalMembers, createdDate, pageLimit } = this.state;
    return (
      <>
        <div className='grid pageContainer_inner'>
          <div className='heading-block gap-10'>
            <div className='block_flex'>
              <h4><i className='back_arrow_icon' onClick={ () => this.handleBack() }><BaclArrow/></i> Group Info & Members</h4>
            </div>
            <div className='block_flex'>
              { exportGroupInfoData && exportGroupInfoData.length !== 0 && <CSVLink
                    data = { exportGroupInfoData }
                    filename = { 'Group Information.csv' }
                    className = 'btn btn_green'
                    onClick={ () => {
                      console.log('Export Data'); // Your click handling logic
                    } }
                  >
                    Export To CSV
                  </CSVLink>
                  
              }
              {/* <button className='btn btn_primary' >Back</button> */}
            </div>
          </div>
          <div className='groupinfo'>
            {/* <div className="action-btn-block">
              
            </div> */}
            <div className='info'>
              <div className='left'>
                <div className='groupimg' name="groupImage">
                  {/* <img src={ groupImage } /> */}
                  <Image imageToken={ groupImage } isGroup={ true } />
                </div>
                <div className='group'>
                  <div className='formgroup'>
                    <label>Group Name:</label>
                    <span>{ getFormattedText(groupName) }</span>
                  </div>
                  <div className='formgroup'>
                    <label>Total Members:</label>
                    <span>{ totalMembers }</span>
                  </div>
                  <div className='formgroup'>
                    <label>Created Date & Time:</label>
                    <span>{ createdDate && formatDateTime(createdDate) }</span>
                  </div>
                </div>
                {/* <div className='right'>

                </div> */}
              </div>
            </div>
            <div className='responsive-table ctTableBox'>
              <DataTable className="data-table"
                keyField="id"
                width="100%"
                pagination={ {
                  enabled: true,
                  pageLength: 5,
                  type: 'long'
                } }
                headers={ this.state.headers }
                data={ GroupsInfoList }
                noData="No records!"
                sortTable={ this.sortTable }
                loading={ loading }
                activeSort={ this.state.activeSort }
              />
              <Pagination
                handleClick={ this.formUrlParams }
                totalRecords={ totalRecords }
                initialPage={ currentPage }
                setPageLimit={ this.setPageLimit }
                pageLimit={ pageLimit }
                updateActiveQuery={ this.updateActiveQuery }
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
